import { ColumnDef } from "@tanstack/react-table";
import type { IcmJob } from "@/icm/types";

const BusinessUnitNameCol: ColumnDef<IcmJob, unknown> = {
  accessorKey: "business_unit_name",
  header: "Business Unit",
  meta: { size: "160px" },
  cell: ({ getValue }) => (getValue() as string | null) ?? "-",
};

export default BusinessUnitNameCol;
